export default {
  bind(el) {
    el.addEventListener('click', () => {
      if (!el.classList.contains('v-btn--loading')) {
        el.classList.add('v-btn--loading');
        el.setAttribute('disabled', 'disabled');

        if (!el.querySelector('.v-btn__loader')) {
          const loader = document.createElement('span');
          loader.className = 'v-btn__loader custom-process-icon';
          loader.innerHTML = `<div class="v-progress-circular v-progress-circular--indeterminate" style="height: 23px; width: 23px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="22.857142857142858 22.857142857142858 45.714285714285715 45.714285714285715" style="transform: rotate(0deg);"><circle fill="transparent" cx="45.714285714285715" cy="45.714285714285715" r="20" stroke-width="5.714285714285714" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172" class="v-progress-circular__overlay"></circle></svg></div>`;
          el.appendChild(loader);
        }

        const resetState = () => {
          el.classList.remove('v-btn--loading');
          el.removeAttribute('disabled');
          const icon = el.querySelector('.custom-process-icon');
          if (icon) icon.remove();
        };

        let apiStarted = false;
        
        const onApiStart = () => { apiStarted = true; };
        const onApiEnd = () => { 
          if (apiStarted) {
             resetState();
             cleanup();
          }
        };

        const cleanup = () => {
           window.removeEventListener('api:start', onApiStart);
           window.removeEventListener('api:end', onApiEnd);
        };

        window.addEventListener('api:start', onApiStart);
        window.addEventListener('api:end', onApiEnd);

        setTimeout(() => {
          if (!apiStarted) {
            resetState();
            cleanup();
          }
        }, 150);
      }
    });
  }
};